import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import StayInTouch from './StayInTouch';

interface PublicShellProps {
  children: React.ReactNode;
  minimalHeader?: boolean;
  hideStayInTouch?: boolean;
}

export default function PublicShell({ children, minimalHeader = false, hideStayInTouch = false }: PublicShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <PublicHeader minimal={minimalHeader} />
      <main className="flex-1">{children}</main>
      {!hideStayInTouch && <StayInTouch />}
      <PublicFooter />
    </div>
  );
}
